import { Dialog } from 'primereact/dialog';

import { useDispatch, useSelector } from 'react-redux';
import { toggleDialog } from '../../../../redux/Slices/Global/globalSlice';
import { useTranslation } from 'react-i18next';

const IcStop = () => <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" /><rect x="9" y="9" width="6" height="6" rx="1" /></svg>;
const IcClose = () => <svg width="18" height="18" viewBox="0 0 24 24" style={{ stroke: 'currentColor', fill: 'none', strokeWidth: 2 }}><path d="M6 6l12 12M18 6L6 18" /></svg>;

function StopConfirmation({ isLoading = false, stopHandler }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { openDialog } = useSelector((state) => state.global);

    const confirmDelete = () => stopHandler();
    const onClose = () => dispatch(toggleDialog("stopConfirmation"))

    return (
        <Dialog visible={openDialog.stopConfirmation}
            style={{ width: '420px' }}
            breakpoints={{ '960px': '95vw' }}
            showHeader={false}
            modal
            className="pp-dlg"
            onHide={onClose}>

            <div className="pp-dlg-hd">
                <span className="ic"><IcStop /></span>
                <div><div className="t">{t('buttons.confirm')}</div></div>
                <span className="x" onClick={onClose}><IcClose /></span>
            </div>
            <div className="pp-dlg-bd">
                <p className="dlgtext">{t('devices.setup_stop_confirm_msg')}</p>
            </div>
            <div className="pp-dlg-ft">
                <button className="btn primary" disabled={isLoading} onClick={confirmDelete}>{t('buttons.yes')}</button>
                <button className="btn ghost" disabled={isLoading} onClick={onClose}>{t('buttons.no')}</button>
            </div>
        </Dialog>
    )
}

export default StopConfirmation
